import { handleError } from "./basic";

export const withTryCatch = async (callback) => {
  try {
    await callback()
  } catch (e) {
    handleError(e);
  }
};
